import React from 'react'
import { connect } from 'redaction'
import { links, compose, getCityName } from 'helpers'
import config from 'local_modules/app-config'
import injectGlobals from 'local_modules/injectGlobals'

import DropLink from './DropLink/DropLink'

import s from './PageNavigation.scss'


const isTestApi = config.api === 'test'
const isDevApi  = config.env === 'development'
const isTest    = isTestApi || isDevApi

const handleReplace = (string) => string.replace(/&&/, '&').replace(/&$/, '').replace(/\?&/, '?').replace(/\?$/, '')


const PageNavigation = ({ links }) => (
  Boolean(links) ? (
    <div className={s.pageNavigation}>
      {
        links.map(({ link, toOLD, title, subNav, localStorageName, onClick }, index) => (
          <DropLink
            key={index}
            title={title}
            link={link}
            toOLD={toOLD}
            subNav={subNav}
            localStorageName={localStorageName}
            onClick={onClick}
          />
        ))
      }
    </div>
  ) : (
    <div id="pageNavigation" />
  )
)


export default compose(
  injectGlobals(({ globals }) => ({
    cityName: getCityName(globals),
  })),
  connect({
    links: (state, props) => {
      const {
        me: { layers },
        routing: {
          locationBeforeTransitions: { query, search, pathname },
        },
      } = state
      const { projectName, cityName } = props

      // if (projectName === 'heroes') {
      //   const isHeroesModerator = (layers.find(({ link }) => link === links.heroes.root) || {}).accessLevel === 1
      //   const heroesLinks = [
      //     {
      //       title: 'Бессмертный полк',
      //       link: links.heroes.root,
      //     },
      //     {
      //       title: 'Мои герои',
      //       link: links.heroes.my,
      //     },
      //     {
      //       title: 'Добавить героя',
      //       link: pathname + '?add',
      //     },
      //   ]
      //
      //   return isHeroesModerator || isTest ? heroesLinks.concat({
      //     title: 'Модерация',
      //     link: links.heroes.moderate,
      //   }) : heroesLinks
      // }

      if (projectName === 'accessible') {
        const isSidewalksActive = query.sidewalk === null
        const prefix            = search ? search + '&' : '?'

        return [
          {
            title: 'Тротуары',
            link: links.accessible.root + (isSidewalksActive ? handleReplace(search.replace(/sidewalk/, '')) : prefix + 'sidewalk'),
          },
          {
            title: 'Сообщить о проблеме',
            toOLD: '/?complainObject={"type":13,"lat":54.93,"lng":43.33}',
          }
        ]
      }

      if (projectName === 'asudd') {
        // const isListActive      = query.list === null
        const isDtpActive       = query.accidents === null
        const isTrafficActive   = query.traffic === null
        const isTransportActive = query.transport === null
        const isCamsActive      = query.cctv === null
        const isRoadsActive     = query.roads === null
        const prefix            = search ? search + '&' : '?'

        return [
          // {
          //   title: 'Список СО',
          //   link: links.asudd.root + (isListActive ? handleReplace(search.replace(/list/, '')) : prefix + 'list'),
          //   search,
          // },
          {
            title: 'ДТП',
            link: links.asudd.root + (isDtpActive ? handleReplace(search.replace(/accidents/, '')) : prefix + 'accidents'),
          },
          {
            title: 'Трафик',
            link: links.asudd.root + (isTrafficActive ? handleReplace(search.replace(/traffic/, '')) : prefix + 'traffic'),
            search,
          },
          {
            title: 'Транспорт',
            link: links.asudd.root + (isTransportActive ? handleReplace(search.replace(/transport/, '')) : prefix + 'transport'),
            search,
          },
          {
            title: 'Камеры',
            link: links.asudd.root + (isCamsActive ? handleReplace(search.replace(/cctv/, '')) : prefix + 'cctv'),
            search,
          },
          {
            title: 'Дороги',
            link: links.asudd.root + (isRoadsActive ? handleReplace(search.replace(/roads/, '')) : prefix + 'roads'),
            search,
          },
        ]
      }
      if (projectName === 'dashboard' && cityName === 'sarov') {
        return [
          {
            title: 'Городские показатели',
            link: links.dashboard.root,
          },
          {
            title: 'Статистика сайта',
            link: links.dashboard.statistic,
          },
        ]
      }
      if (projectName === 'transport') {
        // const localStorageName = `${projectName}_pageNav_configLayer`

        return [
          {
            title: 'Маршруты',
            link: links.transport.root,
          },
          {
            title: 'План графики',
            link: links.transport.plan,
          },
          {
            title: 'Расписание',
            link: links.transport.schedule,
          },
          {
            title: 'План графики 2',
            link: links.transport.plan2,
          },
          {
            title: 'Настройки',
            link: links.transport.config,
          },
        ]
      }
      if (projectName === 'lscTransportControl') {
        return [
          {
            title: 'Отчёт',
            link: links.lscTransportControl.report,
          },
          // {
          //   title: 'Нарушения',
          //   link: links.lscTransportControl.violation,
          // },
          {
            title: 'Отклонения',
            link: links.lscTransportControl.deviation,
          },
        ]
      }
      if (projectName === 'voting') {
        const {
          voting: {
            accessLevel: { isAdmin },
            homePage, projectPage,
          },
        } = state

        const countNumber = homePage.poll.length || projectPage.poll.length
        const count       = countNumber ? `<span class="count">${countNumber}</span>` : ''

        if (isAdmin) {
          return [
            {
              title: `Голосования${count}`,
              link: links.voting.root,
            },
            {
              title: 'Редактирование',
              link: links.voting.admin.root,
            },
            {
              title: 'Добавить',
              link: links.voting.admin.add,
            },
          ]
        }
        else {
          return [
            {
              title: `Голосования${count}`,
              link: links.voting.root,
            },
          ]
        }
      }

      return null
    }
  }),
)(PageNavigation)
